import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseGamePage } from '../../games/ase-game-page.component';
import { FrontPageGamesService } from 'src/app/services/page/front-games.service';
import { Subject, debounceTime, map, switchMap, takeUntil, tap, zip } from 'rxjs';
import { GameCategory, GameItem } from 'src/app/apollo/models/base-models';
import { SwiperConfig } from '../../games/search-game/search-game-swiper/search-game-swiper.component';
import { SearchConfig, SearchGameService } from 'src/app/services/games/search-game.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchGameComponent } from '../../games/search-game/search-game.component';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { gameInfoTrx } from 'src/app/router-translation.labels';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { Location } from '@angular/common';

export const swiperCategoriesConfig: SwiperConfig = {
  width: '100%',
  swiperContainerHeight: '100px',
  swiperWrapperHeight: '80px',
  gap: '10px',
  loop: true,
  alignItems: 'center',
}

export const gameCategoriesConfig: SwiperConfig = {
  width: '100%',
  swiperContainerHeight: '246px',
  swiperWrapperHeight: '246px',
  gap: '16px',
  loop: true,
  swipeToMove: 6,
  alignItems: 'flex-start',
}

@Component({
  selector: 'app-desktop-search',
  templateUrl: './desktop-search.component.html',
  styleUrls: ['./desktop-search.component.scss']
})
export class DesktopSearchComponent extends BaseGamePage implements OnInit {

  public swiperCategories: GameCategory[];
  public swiperSelectedCategory: GameCategory;
  public gameCategories: GameCategory[];
  public selectedCategory: GameCategory;
  public swiperSelectedGame: GameItem;

  public swiperCategoriesConfig = swiperCategoriesConfig;
  public gameCategoriesConfig = gameCategoriesConfig;

  public swipeToFrontEvent = new EventEmitter<{ id: number }>();
  public swipeToBackEvent = new EventEmitter<{ id: number }>();

  private swipeToFrontSubject = new Subject<{ id: number }>();
  private swipeToBackSubject = new Subject<{ id: number }>();

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private frontPageGamesService: FrontPageGamesService,
    private searchGamesService: SearchGameService,
    protected translationConfig: TranslationConfig,
  ) {
    super(dialog);

    this.swipeToFrontSubject.pipe(debounceTime(50)).subscribe((event) => {
      this.swipeToFrontEvent.emit(event);
    });

    this.swipeToBackSubject.pipe(debounceTime(50)).subscribe((event) => {
      this.swipeToBackEvent.emit(event);
    });

  }
  
  ngOnInit() {
    this.frontPageGamesService.fetchData().pipe(takeUntil(this.unsubscribe)).subscribe((response) => {
      this.swiperCategories = response.pagesCategories[0]?.categories.filter((item) => {
        return item.displayName && item.displayName.trim() !== '';
      });

      this.swiperCategories = this.formatText(this.swiperCategories);
      this.gameCategories = this.swiperCategories.slice(0, 3);  //  for now

    });

    this.openSearchDialog(); // Init desktop search popup

  }

  /* ------------------------------------------------------------------------------- */

  swipeToFront(id: number) {
    this.swipeToFrontSubject.next({ id });
  }

  swipeToBack(id: number) {
    this.swipeToBackSubject.next({ id });
  }

  /* ------------------------------------------------------------------------------- */

  formatText(categories: GameCategory[]) {
    return categories.map((category) => {
      const words = category.displayName.split(' ');
      let formattedDisplayName;
      if (words.length > 1) {
        formattedDisplayName = `${words[0]}<br>${words.slice(1).join(' ')}`;
      } else {
        formattedDisplayName = category.displayName;
      }
      return {
        ...category,
        formattedDisplayName
      };
    });
  }

  setSelectedCategory(category: GameCategory) {
    this.swiperSelectedCategory = category;
  }

  setSelectedGame(game: GameItem) {
    this.swiperSelectedGame = game;
  }

  onCategoryClick(category: any) {
    console.log('category =>', category);
    this.searchGamesService.saveSearchHistory('');

    this.searchGamesService.setSearchSwiper(category.name);

    this.openSearchDialog();
  }

  onGameClick(game: any) {
    this.router.navigate(["", this.translationConfig.getTranslation(gameInfoTrx), game.systemName]);
  }

  /* ------------------------------------------------------------------------------- */

  openSearchDialog(): void {
    const dialogRef = this.dialog.open(SearchGameComponent, {
      width: '646px',
      height: '80vh',
      backdropClass: 'blur-backdrop',
      panelClass: ['transparent', 'search-wrapper']
    });

    dialogRef.afterClosed().subscribe(result => {
      //this.router.navigate(['/']);
    });
    
  }

}
